<template>
  <div>
    <el-container class="container">
      <el-header height="30px" class="no-padding header">
        <span v-text="showTitle"></span>
        <!-- <div class="addbtn" @click="systemEmojiBox = true">系统表情</div> -->
      </el-header>
      <el-main class="no-padding main lum-scrollbar">
        <input type="file" ref="fileCustomEmoji" accept="image/*" style="display: none" @change="customUploadEmoji" />

        <!-- QQ表情 -->
        <div v-show="showEmoticonId == -1" class="emoticon">
          <!-- <div class="title">QQ表情</div> -->
          <div v-for="(elImg, text) in emoji.emojis" v-html="elImg" :key="text" class="emoticon-item"
            @click="clickEmoticon(text)"></div>
          <div class="clear"></div>
          <div class="title">符号表情↓</div>
          <div v-for="(item, i) in emoji.symbol" :key="i" class="emoticon-item symbol" @click="clickEmoticon(item)">
            {{ item }}
          </div>
          <div class="clear"></div>
        </div>

        <!-- 自定义表情 -->
        <div v-for="item in emojiItem.slice(1)" v-show="item.emoticon_id == showEmoticonId" :key="item.emoticon_id"
          class="emoji-box">
          <div class="emoji-item custom-emoji" @click="$refs.fileCustomEmoji.click()">
            <i class="el-icon-picture" />
            <span>上传表情</span>
          </div>
          <div v-if="userSelfEmojis.content.length === 0" style="padding-top: 25px; padding-left: 105px;">请点击上传表情</div>
          <div v-for="(subitem, index) in userSelfEmojis.content" class="emoji-item" :key="index"
            @click="clickImageEmoticon(subitem)" @click.right="rightEvent(subitem)" @contextmenu="onContextmenu">
            <el-image :src="subitem.fileUrl" fit="cover" />
          </div>
          <div class="clear"></div>
        </div>
      </el-main>
      <el-footer height="40px" class="no-padding footer">
        <div class="toolbar-items">
          <div v-show="emojiItem.length > 13" class="toolbar-item prev-page" @click="turnPage(1)">
            <i class="el-icon-caret-left" />
          </div>
          <div v-for="(item, index) in showItems" :key="index" class="toolbar-item" @click="triggerItem(item)">
            <img :src="item.url" />
            <p class="title">{{ item.name }}</p>
          </div>
          <div v-show="emojiItem.length > 13 && showItems.length == 13" class="toolbar-item next-page"
            @click="turnPage(2)">
            <i class="el-icon-caret-right" />
          </div>
        </div>
      </el-footer>
    </el-container>

    <MeEditorSystemEmoticon v-if="systemEmojiBox" @close="systemEmojiBox = false" />

    <vue-context-menu :contextMenuData="emojiContextMenuData" @HandlerDelete="Handler_delete" @HandlerPreview="Handler_preview">
    </vue-context-menu>
  </div>
</template>

<script>
import MeEditorSystemEmoticon from '@/components/dashboard/main/chat/widgets/editor/MeEditorSystemEmoticon'
import { emojiList as emoji } from '@/util/emojis'
import { mapState, mapGetters, mapActions } from 'vuex'
const constants = require('@/util/constants')
// import bus from '@/util/eventbus'

export default {
  name: 'MeEditorEmoticon',
  components: {
    MeEditorSystemEmoticon,
  },
  computed: {
    ...mapGetters([ 'userInfo', 'userSelfEmojis' ]),
    ...mapState({
      emojiItem: state => state.emoticon.items,
    }),
    showItems() {
      let start = (this.page - 1) * this.pageSize
      let end = start + this.pageSize
      return this.emojiItem.slice(start, end)
    },
    pageTotal() {
      return this.emojiItem.length / this.pageSize
    },
  },
  data() {
    return {
      emoji,
      // 系统表情包套弹出窗
      systemEmojiBox: false,
      //
      showEmoticonId: -1,
      // showTitle: 'QQ表情/符号表情',
      showTitle: '默认表情',
      //
      page: 1,
      pageSize: 13,
      // 接收图片服务器地址
      // uploadImageServerUrl: constants.UPLOAD_EMOJI_URL,
      uploadImageServerUrl: constants.UPLOAD_FILE_URL_V3,
      electron: constants.IS_ELECTRON,
      //
      rightSelectedItem: {
        id: 0,
        uid: '',
        type: 'emoji',
        fileUrl: ''
      },
      emojiContextMenuData: {
        menuName: "emojiContextMenu",
        axis: {
          x: null,
          y: null
        },
        menulists: [
          {
            btnName: this.$t("delete"),
            icoName: "el-icon-delete",
            fnHandler: "HandlerDelete"
          },
          {
            btnName: this.$t("preview"),
            icoName: "el-icon-view",
            fnHandler: "HandlerPreview"
          },
        ]
      }
    }
  },
  created() {
    // this.$store.commit('LOAD_USER_EMOTICON')
  },
  mounted() {
    // let app = this
    // bus.$on(constants.EVENT_BUS_SHOW_EMOTION_POPOVER, () => {
    //   // console.log('EVENT_BUS_SHOW_EMOTION_POPOVER')
    //   // app.query()
    // })
  },
  methods: {
    ...mapActions(['queryEmojis', 'addEmoji', 'deleteEmoji' ]),
    //
    query () {
      let payload = { page: 0, size: 20, type: 'emoji' }
      this.queryEmojis(payload)
    },
    // 表情包导航翻页
    turnPage(type) {
      console.log('turnPage:' + type)
      if (type == 1) {
        if (this.page == 1) return false
        this.page--
      } else {
        if (this.page >= this.pageTotal) return false
        this.page++
      }
    },

    // 点击表情包导航
    triggerItem(item) {
      console.log('triggerItem:' + item.emoticon_id)
      this.showEmoticonId = item.emoticon_id
      this.showTitle = item.name
      if (item.emoticon_id === 0) {
        this.query()
      }
    },

    // 选中表情
    clickEmoticon(emoji) {
      this.callback({
        type: 1,
        value: emoji,
      })
    },

    // 发送图片表情包
    clickImageEmoticon(item) {
      console.log('clickImageEmoticon:', item)
      this.callback({
        type: 2,
        value: item.fileUrl,
      })
    },

    showContextMenu() {
      // this.transferIndex = index; // tranfer index to child component
      event.preventDefault();
      var x = event.clientX;
      var y = event.clientY;
      this.emojiContextMenuData.axis = {
        x,
        y
      };
    },

    // 
    Handler_delete() {
      console.log('Handler_delete')
      let id = this.rightSelectedItem.id
      this.deleteEmoji(id)
    },

    // 
    Handler_preview() {
      // console.log('Handler_preview')
      if (this.electron) {
        ipcRenderer.send("open-external-url", this.rightSelectedItem.fileUrl);
      } else {
        window.open(this.rightSelectedItem.fileUrl);
      }
    },

    // 
    rightEvent(item) {
      console.log('rightEvent:', item)
      this.rightSelectedItem = item
    },

    // 引用第三方组件: https://github.com/GitHub-Laziji/menujs
    onContextmenu(event) {
      // console.log('onContextmenu:', event)
      // if (this.electron) {
        this.showContextMenu()
      //   return
      // }
      // FIXME: 不显示？
      // this.$contextmenu({
      //   items: [
      //     {
      //       label: this.$t("delete"),
      //       icon: "el-icon-delete",
      //       onClick: () => {
      //         // console.log("删除");
      //         // this.restartThread(this.rightSelectThread);
      //       },
      //     },
      //   ],
      //   event,
      //   // customClass: "custom-class",
      //   zIndex: 3,
      //   minWidth: 130,
      // });
      // // return false;
      // event.preventDefault();
    },

    callback(data) {
      this.$emit('selected', data)
    },

    // 自定义上传表情
    customUploadEmoji(e) {
      if (e.target.files.length == 0) {
        return false
      }
      //
      let file = e.target.files[0]
      this.uploadImage(file)
    },

    uploadImage(file) {
      let app = this
      this.compressImage(file, function (newFile) {
        console.log('compressImage')
        //
        let filename = moment(new Date()).format('YYYYMMDDHHmmss')
        if (file.type === 'image/jpeg') {
          filename = filename + '.jpg'
        } else if (file.type === 'image/png') {
          filename = filename + '.png'
        }
        //
        var formdata = new FormData();
        formdata.append("file_name", filename);
        formdata.append("username", app.userInfo.username);
        formdata.append("type", constants.UPLOAD_FILE_TYPE_EMOJI)
        formdata.append("file", newFile);
        formdata.append("client", 'web');
        //
        $.ajax({
          url: app.uploadImageServerUrl,
          contentType: false,
          cache: false,
          processData: false,
          mimeTypes:"multipart/form-data",
          type: "post",
          data: formdata,
          success:function(response) {
            // upload response: https://bytedesk.oss-cn-shenzhen.aliyuncs.com/images/20220701112852.png
            console.log('upload response:', response.data)
            let emojiUrl = response.data
            app.addEmoji(emojiUrl)
          },
          error: function(error) {
            console.log(error)
            // app.$message.error(app.$t('uploadfailed'))
            // app.$notify({ title: app.$t('tip'), message: app.$t('sendImageError'), type: 'error' })
          }
        })
      })
    },
    //
    compressImage(file, callback) {
      // 判断文件大小
      if (file.size > 1024 * 1024 * 1) {
        console.log('图片大于1M进行压缩')
        //
        this.canvasDataURL(file, function (blob) {
          //
          var newFile = new File([blob], file.name, {
            type: file.type
          })
          var isLt1M;
          if (file.size < newFile.size) {
            isLt1M = file.size
          } else {
            isLt1M = newFile.size
          }
          console.log('file.size:' + (file.size / 1024 / 1024))
          console.log('newFile.size: ' + (newFile.size / 1024 / 1024))
          // 
          if (file.size < newFile.size) {
            callback(file)
          }
          callback(newFile)
        })
      } else {
        console.log('图片小于1M直接上传')
        // 
        return callback(file)
      }
    },
    // 图片压缩方法
    canvasDataURL (file, callback) {
      console.log('canvasDataURL')
      //
      let app = this
      var reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = function (e) {
        const img = new Image()
        const quality = 0.1 // 图像质量
        const canvas = document.createElement('canvas')
        const drawer = canvas.getContext('2d')
        img.src = app.result
        img.onload = function () {
          canvas.width = img.width
          canvas.height = img.height
          drawer.drawImage(img, 0, 0, canvas.width, canvas.height)
          return app.convertBase64UrlToBlob(canvas.toDataURL("image/jpeg", quality), callback);
        }
      }
    },
    // 将以base64的图片url数据转换为Blob
    convertBase64UrlToBlob (urlData, callback) {
      console.log('convertBase64UrlToBlob')
      // 
      var bytes = window.atob(urlData.split(',')[1]);        //去掉url的头，并转换为byte  
      //处理异常,将ascii码小于0的转换为大于0  
      var ab = new ArrayBuffer(bytes.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }
      var blob = new Blob([ab], { type: 'image/jpeg' });  
      callback(blob)
    },


  },
}
</script>
<style lang="less" scoped>
.container {
  height: 300px;
  width: 500px;
  background-color: white;

  .header {
    line-height: 30px;
    font-size: 13px;
    font-weight: 400;
    padding-left: 5px;
    user-select: none;
    position: relative;
    border-bottom: 1px solid #fbf5f5;

    .addbtn {
      position: absolute;
      right: 10px;
      top: 1px;
      color: #409eff;
      cursor: pointer;
    }
  }

  .footer {
    background-color: #eff1f7;

    .toolbar-items {
      width: 100%;
      height: 40px;
      line-height: 40px;
      display: flex;
      flex-direction: row;
      align-items: center;

      .toolbar-item {
        height: 30px;
        width: 30px;
        margin: 0 2px;
        background-color: #fff;
        display: inline-block;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;

        img {
          width: 20px;
          height: 20px;
        }

        .title {
          display: none;
          position: absolute;
          top: -25px;
          left: 0px;
          height: 20px;
          line-height: 20px;
          background: #353434;
          color: white;
          min-width: 30px;
          font-size: 10px;
          padding-left: 5px;
          padding-right: 5px;
          border-radius: 2px;
          white-space: pre;
          text-align: center;
        }

        &:hover .title {
          display: block;
        }
      }
    }
  }
}

.container .footer .toolbar-items .prev-page:active i,
.container .footer .toolbar-items .next-page:active i {
  transform: scale(1.2);
}

.emoji-box,
.emoticon {
  width: 100%;
}

.emoticon {
  .title {
    width: 50%;
    height: 25px;
    line-height: 25px;
    color: #ccc;
    font-weight: 400;
    padding-left: 3px;
    font-size: 12px;
  }

  .emoticon-item {
    width: 30px;
    height: 30px;
    margin: 2px;
    float: left;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
      transform: scale(1.3);
    }
  }

  .symbol {
    font-size: 22px;
  }
}

.emoji-box {
  .emoji-item {
    width: 67px;
    height: 67px;
    margin: 2px;
    background-color: #eff1f7;
    float: left;
    cursor: pointer;
    transition: ease-in 0.3s;
  }

  .custom-emoji {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 10px;

    i {
      font-size: 30px;
      margin-bottom: 3px;
    }

    &:active {
      color: #409eff;
    }
  }
}

/deep/ .el-image {
  width: 100%;
  height: 100%;
  transition: ease-in 0.3s;
}

.emoji-box .emoji-item:hover .el-image,
.emoji-box .emoji-item:hover {
  border-radius: 10px;
}
</style>
